angular.module("warsApp").config(['$provide', function ($provide) {

    $provide.decorator('uibDatepickerPopupDirective', ['$delegate', function ($delegate) {
    var directive = $delegate[0];
    var link = directive.link;

    directive.compile = function () {
      return function (scope, element, attrs) {
        link.apply(this, arguments);
        element.mask("99/99/9999");
        element[0].onblur = function() {
            if (!scope.date) {
                element[0].value = "";
            }
        }
      };
    };
    return $delegate;
  }]);

}]);

angular.module("warsApp.directives").directive('myDatepicker', ['$parse', 'dateFilter', function ($parse, dateFilter) {
    return {
        restrict: 'E',
        scope:true,
        require: 'ngModel',
        compile: function compile(element, attrs) {
            var html = '<div class="input-group">' +
                '<input id="' + attrs.identifier + '" type="text" title="' + attrs.titletagdescription + '" class="form-control" is-open="popupOpen" ng-disabled="' + attrs.disabled + '" ng-required="' + attrs.required + '" uib-datepicker-popup="MM/dd/yyyy" ng-model="' + attrs.ngModel + '" ng-change="model.fieldChanged()" ng-model-options="{ updateOn: \'default blur\', debounce: { \'default\': 1000, \'blur\': 0 } }"/>' +
                '<span class="input-group-btn">' +
                '<button type="button" class="btn btn-default" title="Open Calendar by pressing enter key" ng-click="openPopup($event)" ng-disabled="' + attrs.disabled + '"><i class="glyphicon glyphicon-calendar"></i></button>' +
                '</span>' +
                '</div>';
            element.replaceWith(html);
            return {
                post: function postLink(scope) {
                        scope.popupOpen = false;
                        scope.openPopup = function($event) {
                            $event.preventDefault();
                            $event.stopPropagation();
                            scope.popupOpen = true;
                        }; 
                }
            }
        }
    };
}]);